import "./PlumbingProblems.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import ProblemsHero from "./sections/ProblemsHero";
import ProblemFinder from "./sections/ProblemFinder";
import ToiletProblems from "./sections/ToiletProblems";
import DrainProblems from "./sections/DrainProblems";
import WaterLeaks from "./sections/WaterLeaks";
import HeaterProblems from "./sections/HeaterProblems";
import WaterPressure from "./sections/WaterPressure";
import SewerProblems from "./sections/SewerProblems";
import PipeProblems from "./sections/PipeProblems";
import FixtureProblems from "./sections/FixtureProblems";
import EmergencyProblems from "./sections/EmergencyProblems";
import ProblemMapping from "./sections/ProblemMapping";
import Diagnosis from "./sections/Diagnosis";
import JonesboroArea from "./sections/JonesboroArea";
import Faq from "./sections/Faq";
import EmergencyHelp from "./sections/EmergencyHelp";
export default function PlumbingProblemsPage() {
  return <div>
      <Header />
      <ProblemsHero />
      <ProblemFinder />
      <ToiletProblems />
      <DrainProblems />
      <WaterLeaks />
      <HeaterProblems />
      <WaterPressure />
      <SewerProblems />
      <PipeProblems />
      <FixtureProblems />
      <EmergencyProblems />
      <ProblemMapping />
      <Diagnosis />
      <JonesboroArea />
      <Faq />
      <EmergencyHelp />
      <Footer />
    </div>;
}